import { handler as giveSolHandler } from "./sol.give";

const workflowSteps = [
    giveSolHandler
];

export default workflowSteps;